module.exports = __webpack_public_path__ + "img/secciones-seleccionado.e2aaf355.png";